export const promo = {
  type: 'promo',
  color: '#0d294c',
  link: 'promo',
  title: {
    ru: '<b>Panda&nbsp;Project&nbsp;—</b> Агентство режиссерских событий',
    en: '<b>Panda&nbsp;Project&nbsp;—</b> Agency of directed events'
  }
}
